<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="标题" prop="titleCn">
                <a-input v-model="queryParam.titleCn" placeholder="请输入标题" />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="状态" prop="isPush">
                <a-select v-model="queryParam.isPush" placeholder="请选择" allow-clear>
                  <a-select-option value="0">未推送</a-select-option>
                  <a-select-option value="1">已推送</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['video:push:add']">
          <a-icon type="plus" />新增
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="sendTime" slot-scope="text, record">
          {{ parseTime(record.sendTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
        <template v-if="record.isPush === 0">
          <a @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['video:push:edit']">
            <a-icon type="edit" />编辑
          </a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)" v-hasPermi="['video:push:remove']">
            <a-icon type="delete" />删除
          </a>
        </template>
        <template v-else>
          <a @click="$refs.createForm.handleView(record)">
            <a-icon type="eye" />查看
          </a>
        </template>
      </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pagePush, delPush } from '@/api/video/push'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { Modal } from 'ant-design-vue'

export default {
  name: 'Push',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        isPush: null,
        titleCn: null,
        contentEn: null,
        toPage: null,
        toUser: null,
        timeType: null,
        sendTime: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          align: 'center',
          width: 80
        },
        {
          title: '简体中文标题',
          dataIndex: 'titleCn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '繁体中文标题',
          dataIndex: 'title',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '英文标题',
          dataIndex: 'titleEn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '马来西亚标题',
          dataIndex: 'titleBm',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '印尼标题',
          dataIndex: 'titleIn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '跳转页面',
          dataIndex: 'toPage',
          ellipsis: true,
          align: 'center',
          customRender: function (toPage) {
            if (toPage == 1) {
              return '目标页面'
            } else if (toPage == 2) {
              return '指定页面'
            } else if (toPage == 3) {
              return '短剧'
            }
          }
        },
        {
          title: '推送用户',
          dataIndex: 'toUser',
          ellipsis: true,
          align: 'center',
          customRender: function (toUser) {
            if (toUser == 1) {
              return '全站'
            }
          }
        },
        {
          title: '发送时间',
          dataIndex: 'sendTime',
          scopedSlots: { customRender: 'sendTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '推送状态',
          dataIndex: 'isPush',
          ellipsis: true,
          align: 'center',
          customRender: val => val === 1 ? '已推送' : '未推送'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询平台推送列表 */
    getList () {
      this.loading = true
     pagePush(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        content: undefined,
        toPage: undefined,
        toUser: undefined,
        timeType: undefined,
        sendTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row ? [row.id] : this.ids
      console.log('删除前的 ids:', ids)

      if (!ids || ids.length === 0) {
        this.$message.warning('请先选择要删除的数据')
        return
      }

      Modal.confirm({
        title: '确认删除所选中数据？',
        content: `删除数据编号：${ids.join(', ')}`,
        onOk: () => {
          const data = ids.map(id => ({ id }))
          console.log('点击确认，准备调用 delPush：', data)
          return delPush(data)
              .then(() => {
                this.$message.success('删除成功')
                this.onSelectChange([], [])
                this.getList()
              })
              .catch(() => {
                this.$message.error('删除失败，请检查接口')
              })
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('video/platform-push/export', {
            ...that.queryParam
          }, `平台推送_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
